const common = {
  // Navbar
  nav_home: 'Home',
  nav_about: 'About Us',
  nav_products: 'Products',
  nav_design: 'Design',
  nav_partners: 'Partners',
  nav_contact: 'Contact',

  // Hero
  hero_badge: '2025 New Collection',
  hero_eyebrow: 'CYAN CHARM · Street Style',
  hero_title_1: 'Walk Free',
  hero_title_2: 'Street Chic',
  hero_title_3: 'Your Way',
  hero_desc: 'Inspired by European streets — where outdoor freedom meets urban refinement. Every bag, your perfect companion.',
  hero_cta_explore: 'Explore Products',
  hero_cta_story: 'Our Story',

  // About
  about_title_1: 'Exquisite Craft',
  about_title_highlight: 'Premium Leather',
  about_title_2: 'Redefining Handbag Aesthetics',
  about_label_material: 'Finest Materials',
  about_label_design: 'Original Design',
  about_label_craft: 'Meticulous Craft',
  about_origin_badge: 'Brand Origin',
  about_slogan_1: 'Born from Passion',
  about_slogan_2: 'Crafted with Heart',
  about_slogan_3: 'Driven by Innovation',
  about_desc: 'We believe every woman deserves the perfect bag. Since our founding in 2015, we have consistently integrated fashion aesthetics into product design, using premium leather and exquisite craftsmanship to create high-end handbags that are both beautiful and practical for modern women.',
  about_learn_more: 'Learn More',
  about_review: 'This is the most satisfying bag I\'ve ever bought. The design is stunning, the leather is soft and delicate, and the capacity is great — perfect for work and dates. Every time I carry it out, friends ask where I got it!',
  about_reviewer_name: 'Lin Xiaowen',
  about_reviewer_title: 'Fashion Blogger · Shanghai',
  about_more_reviews: 'View More Reviews',

  // Products
  products_badge: 'All Collections',
  products_title_1: 'Curated Handbags',
  products_title_2: 'Made for Her',
  products_view_detail: 'View Details',
  products_view_all: 'View All Products',
  product_1_name: 'Élite Tote',
  product_1_category: 'Tote Bag Series',
  product_2_name: 'Chic Shoulder',
  product_2_category: 'Shoulder Bag Series',
  product_3_name: 'Luxe Clutch',
  product_3_category: 'Clutch Series',
  product_4_name: 'Mini Charm',
  product_4_category: 'Mini Bag Series',

  // Design
  design_title_highlight_1: 'Sustainable',
  design_title_1: 'Design Philosophy',
  design_title_2: 'Fused with',
  design_title_highlight_2: 'Fashion Aesthetics',
  design_label_eco: 'Eco Material R&D',
  design_label_creative: 'Creative Design',
  design_label_craft: 'Artisan Craft',
  design_quote_light: 'Design',
  design_quote_bold: 'Born from a Love of Beauty',
  design_explore: 'Explore Design Stories',
  design_eco_title: 'Eco First',
  design_eco_desc: 'Using 100% recyclable leather and eco-friendly dyeing processes to reduce carbon footprint and contribute to sustainable development.',
  design_original_title: 'Original Design',
  design_original_desc: 'Each season brings a new original collection blending Eastern and Western aesthetics, making every bag a unique fashion statement.',
  design_quality_title: 'Artisan Quality',
  design_quality_desc: 'Every process is strictly controlled — hand stitching and precision hardware ensure durability that accompanies you every day.',

  // Partners
  partners_badge: 'Partner Brands',
  partners_title_1: 'Creating Together',
  partners_title_2: 'A Fashion Future',
  partners_desc: 'We build deep collaborations with leading global fashion brands to explore the infinite possibilities of handbag design — from fashion media to celebrity collaborations, from eco initiatives to luxury hotels.',
  partners_cta: 'Become a Partner',
  partner_1_name: 'Vogue China',
  partner_1_desc: 'Fashion Media Partner',
  partner_2_name: 'Luxury Hotels',
  partner_2_desc: 'Exclusive Hotel Gifts',
  partner_3_name: 'Fashion Week',
  partner_3_desc: 'Runway Collaboration',
  partner_4_name: 'Eco Alliance',
  partner_4_desc: 'Green Initiative',
  partner_5_name: 'Celebrity Style',
  partner_5_desc: 'Celebrity Collab Series',

  // Contact
  contact_title_light: 'Follow Us',
  contact_title_bold: 'Stay Connected',
  contact_xhs_label: 'Xiaohongshu',
  contact_xhs_desc: 'Scan to follow, get style inspiration',
  contact_dy_label: 'Douyin',
  contact_dy_desc: 'Scan to follow, explore new arrivals',
  contact_wx_label: 'WeChat',
  contact_wx_desc: 'Scan to follow, get exclusive offers',
  contact_address_label: 'Address',
  contact_address_value: 'Baiyun District\nGuangzhou, Guangdong',
  contact_email_label: 'Email',
  contact_phone_label: 'Phone',

  // Footer
  footer_brand_desc: 'Dedicated to creating premium fashion handbags\nBlending fashion aesthetics with exquisite craftsmanship\nProviding exceptional experiences for modern women',
  footer_subscribe_title: 'Newsletter',
  footer_subscribe_placeholder: 'Enter your email',
  footer_privacy: 'Privacy Policy',
  footer_subscribe_tip: 'By subscribing you agree to our',
  footer_links_title: 'Quick Links',
  footer_follow_title: 'Follow Us',
  footer_copyright: '© 2025 Luxe Bag. All rights reserved.',
};

export default common;
